import React from 'react'
import styled from 'styled-components'
import { Failedimg } from 'src/assets'
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 90vh;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  p {
    width: 389px;
    font-weight: 300;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 30px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.gray};
    text-align: center;
    margin-top: -15px;
  }
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-size: ${({ theme }) => theme.fontSize.xx1};
    line-height: 32px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.colors.dark};
  }
`
const Failed = () => {
  return (
    <Wrapper>
      <img src={Failedimg} alt="" />
      <h1>Quicksave Failed!</h1>
      <p>
        You do not have enough money in your bank account or something is wrong
        with your network
      </p>
    </Wrapper>
  )
}
const Faillure = () => {
  return (
    <Wrapper>
      <img src={Failedimg} alt="" />
      <h1>Withdrawal Failed!</h1>
      <p>
        You do not have enough money in your bank account or something is wrong
        with your network
      </p>
    </Wrapper>
  )
}

export { Failed, Faillure }
